import React from 'react'

export const Notes = props => (
  <svg
    width={40}
    height={40}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12.3599 5.00065C11.9139 6.02142 11.6665 7.14882 11.6665 8.33398C11.6665 10.1749 13.1589 11.6673 14.9998 11.6673H24.9998C26.8408 11.6673 28.3332 10.1749 28.3332 8.33398C28.3332 7.14882 28.0858 6.02142 27.6398 5.00065H29.9998C31.8408 5.00065 33.3332 6.49303 33.3332 8.33398V33.334C33.3332 35.175 31.8408 36.6673 29.9998 36.6673H9.99984C8.15889 36.6673 6.6665 35.175 6.6665 33.334V8.33398C6.6665 6.49303 8.15889 5.00065 9.99984 5.00065H12.3599ZM19.9998 23.334H14.9998C14.0794 23.334 13.3332 24.0802 13.3332 25.0007C13.3332 25.9212 14.0794 26.6673 14.9998 26.6673H19.9998C20.9203 26.6673 21.6665 25.9212 21.6665 25.0007C21.6665 24.0802 20.9203 23.334 19.9998 23.334ZM24.9998 16.6673H14.9998C14.0794 16.6673 13.3332 17.4135 13.3332 18.334C13.3332 19.1887 13.9766 19.8932 14.8055 19.9894L14.9998 20.0007H24.9998C25.9203 20.0007 26.6665 19.2545 26.6665 18.334C26.6665 17.4135 25.9203 16.6673 24.9998 16.6673ZM19.9998 3.33398C21.4807 3.33398 22.8112 3.97773 23.7267 5.00065C24.4392 5.79679 24.9004 6.82261 24.9856 7.95335L24.9998 8.33398H14.9998C14.9998 7.12587 15.4283 6.01782 16.1416 5.15352L16.273 5.00065C17.1885 3.97773 18.519 3.33398 19.9998 3.33398Z'
    />
  </svg>
)